module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADLSURBVHgB7VW7EcIwDJWBgjJskHSMwDhsgOnSQUuF2QA2ofQWyQjZAJ44uMsJf5Jcksrv7p18lqUnuXlEE0PFHmitTxzATKQa8G6MOYbql5HmV4QSXDvSfLcDlLX26euxojD231hg0lqI5wgVeADPvgYLCuPzLbK5uMtCDVRrIp4mp3FQY4CCD7ENxgc2eTGpJ3x1k2+QBJJAEkgCAwXYCn+G0gmtt43MuRztBrIPVyiknnjIiz9PZn+Fz25w3JLbi13gyS8wmZLmxhuhxzac7tdUEgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/trash.png
// module id = vWFd
// module chunks = 1